import { TimelineMax } from 'gsap';
// import { random } from 'lodash';

const ShareTextEnter = (split) => {
  // const spans = split.chars;
  const tl = new TimelineMax({ paused: true });
  // tl.addLabel('start');
  // for (let i = 0; i < 20; i += 1) {
  //   spans.forEach(span => tl.to(span, 0, {
  //     innerText: String.fromCharCode(random(97, 122)),
  //   }, `start+=${0.1 * i}`));
  // }
  // spans.forEach((span, index) => tl.to(span, 0, {
  //   innerText: spans[index].innerText,
  // }, '+=0.01'));
  return tl;
};

export default ShareTextEnter;
